import { getData, postData, putData, deleteData, patchData } from './api.service';

/**
 * Obtener todos los productos de stock local
 */
export const getStockProducts = async (includeInactive = false) => {
  const url = `/api/stock-local${includeInactive ? '?include_inactive=true' : ''}`;
  return await getData(url);
};

/**
 * Obtener un producto por ID
 */
export const getStockProductById = async (id) => {
  return await getData(`/api/stock-local/${id}`);
};

/**
 * Crear nuevo producto
 */
export const createStockProduct = async (productData) => {
  return await postData('/api/stock-local', productData);
};

/**
 * Actualizar producto
 */
export const updateStockProduct = async (id, productData) => {
  return await putData(`/api/stock-local/${id}`, productData);
};

/**
 * Desactivar producto
 */
export const deleteStockProduct = async (id) => {
  return await deleteData(`/api/stock-local/${id}`);
};

/**
 * Actualizar cantidad de stock
 */
export const updateStockQuantity = async (id, quantity) => {
  return await patchData(`/api/stock-local/${id}/quantity`, { stock_quantity: quantity });
};

/**
 * Reactivar producto
 */
export const reactivateStockProduct = async (id) => {
  return await patchData(`/api/stock-local/${id}/reactivate`, {});
};
